var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.sections),function(s){return _c('div',{staticClass:"info-section alt-color-rev"},[_c('div',{staticClass:"main",domProps:{"innerHTML":_vm._s(s)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }